import {
  ChangeDetectorRef,
  Directive,
  inject,
  input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { UserRole } from '@qaroni-app/workers/types/user-role';
import { UserRoleEnum } from '@qaroni-app/workers/types/user-role.enum';
import { UserRoleGuardService } from '@qaroni-core/services/app/user-role-guard/user-role-guard.service';

@Directive({
  selector: '[qaroniRoleAccessPermission]',
  standalone: true,
})
export class RoleAccessPermissionDirective
  extends QarepaBaseSubsDirective
  implements OnInit
{
  readonly qaroniRoleAccessPermission = input<boolean | ''>(false);

  private userRoleGuardService = inject(UserRoleGuardService);
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private readonly cdr = inject(ChangeDetectorRef);
  private userRole$ = this.userRoleGuardService.getUserRole$();

  ngOnInit(): void {
    this.subs.add(this.userRole$.subscribe(this.getUserRole));
  }

  private getUserRole = (userRoleData: UserRole) => {
    this.viewContainer.clear();

    if (
      userRoleData?.role &&
      this.userRoleGuardService.hasAccess(
        userRoleData.role as UserRoleEnum,
        this.qaroniRoleAccessPermission() === true
      )
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }

    this.cdr.markForCheck();
  };
}
